import { buildCrustdataFilters } from '@/containers/search/people-search-hook';
import { hasDynamicPeopleExclusions } from '@/containers/search/people-exclusion-validation';
import type { SearchFilters } from '@/types/search-filters';

export const COUNT_PEOPLE_EMPTY = 'Set who to count at each company';
export const COUNT_PEOPLE_EXCLUDES =
  "Count people can't apply CRM, list, Instantly, URL or domain excludes. Remove them";

/**
 * What stops a Count people audience from counting as shown, or null. The
 * API reads only the compiled wire (audienceWireFilters), so the wire must
 * have a condition, and the excludes it never compiles (CRM, Cleanlist,
 * Instantly, profile URLs, company domains) are refused instead of
 * dropped. A bad saved blob comes back as a reason, never a throw: the
 * builder and agent page run this while rendering.
 */
export function countPeopleIssue(filters: unknown): string | null {
  if (!filters || typeof filters !== 'object') return COUNT_PEOPLE_EMPTY;
  const f = filters as SearchFilters;
  try {
    if (
      hasDynamicPeopleExclusions(f) ||
      (f.excludeProfileUrls?.length ?? 0) > 0 ||
      (f.excludeCompanyDomains?.length ?? 0) > 0
    )
      return COUNT_PEOPLE_EXCLUDES;
    return Object.keys(buildCrustdataFilters(f)).length > 0
      ? null
      : COUNT_PEOPLE_EMPTY;
  } catch (error) {
    return error instanceof Error && error.message
      ? error.message
      : 'Fix the people filters';
  }
}
